import useAttribute from "@hooks/useAttribute"

export default function useNameAttribute(salon: Model.Response<{ name: string }>) {
    return useAttribute(salon.data, salon => {
        return salon.name
    }, "Loading...")
}